import React, { useState, useEffect, useCallback } from 'react';
import { MainProvider, MainProviderProps } from './MainProvider';
import { EventProvider } from './EventProvider';
import { MicroFrontendProps } from '../core';

interface AppContextProps {
  props?: any;
  setProps?: React.Dispatch<React.SetStateAction<any | undefined>>;
}

export const AppContext = React.createContext<AppContextProps>({});

export interface AppProviderProps extends MainProviderProps {
  propsEvent: string;
};

export const AppProvider = ({
  client,
  tryGuestLogin,
  getClient,
  propsEvent,
  children,
  ...initialProps
}: AppProviderProps) => {
  const [props, setProps] = useState<Partial<MicroFrontendProps>>(initialProps);

  const handlePropsUpdate = useCallback((event: Event) => {
    setProps((event as CustomEvent).detail);
  }, []);

  useEffect(() => {
    window.addEventListener(propsEvent, handlePropsUpdate);
    return () => window.removeEventListener(propsEvent, handlePropsUpdate);
  }, [propsEvent, handlePropsUpdate]);

  const graphClient = getClient?.({ lang: initialProps.lang, tryGuestLogin });
  const finalClient = graphClient?.client || client;

  return (
    <AppContext.Provider value={{ props, setProps }}>
      <MainProvider finalClient={finalClient} {...props}>
        <EventProvider>
          {children}
        </EventProvider>
      </MainProvider>
    </AppContext.Provider>
  );
};
